import { handleRequest } from "../utilities/requestHandler";

export const getAllMachineModels = () =>
    handleRequest("get", "/machines/models");

export const getAllOptions = () =>
    handleRequest("get", "/options/");

export const sendPasswordResetLink = (req_body) =>
    handleRequest("post","/users/passwordresetlink", req_body);

export const deleteUsers = (req_body) =>
    handleRequest("post","/users/delete",req_body);

export const insertOptions = (req_body) =>
    handleRequest("post","/options/insert",req_body);

export const getEndpointData = (endpoint) =>
    handleRequest("get", endpoint);

export const getVersionInfo = () => handleRequest("get", "/system/version");
